import { html, LitElement } from 'lit';
import styles from './toujou-top-button.css';

class ToujouTopButton extends LitElement {
  static get is() {
    return 'toujou-top-button';
  }

  static get styles() {
    return styles;
  }

  static get properties() {
    return {
      visible: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();
    this.visible = false;
    this.settings = {
      visibleClass: 'topbutton--visible', // necessary due to custom css
    };
    this._checkVisibility = this._checkVisibility.bind(this);
  }

  render() {
    return html`
      <slot id="content"></slot>
    `;
  }

  connectedCallback() {
    super.connectedCallback();

    this.setAttribute('role', 'button');
    this._checkVisibility();

    window.addEventListener('scroll', this._checkVisibility);
    window.addEventListener('resize', this._checkVisibility);

    this.addEventListener('click', this._handleClick);
    this.addEventListener('keyup', this._handleKeyUp);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._checkVisibility);
    window.addEventListener('resize', this._checkVisibility);

    this.removeEventListener('click', this._handleClick);
    this.removeEventListener('keyup', this._handleKeyUp);

    super.disconnectedCallback();
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has('visible')) {
      this.setAttribute('aria-hidden', (!this.visible).toString());
      this.classList.toggle(this.settings.visibleClass, this.visible);
    }
  }

  /**
   * @return {number}
   *
   * @private
   */
  get _viewportHeight() {
    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  }

  /**
   * @private
   */
  _checkVisibility() {
    this.visible = document.body.scrollTop > this._viewportHeight
      || document.documentElement.scrollTop > this._viewportHeight;
  }

  /**
   * @private
   */
  _handleClick() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    this._resetFocus();
  }

  /**
   * Handle Enter or Space press when focus is on the element
   * @param event
   * @private
   */
  _handleKeyUp(event) {
    if (event.key === 'Enter' || event.code === 'Enter' || event.code === 'Space' || event.key === ' ') {
      this._handleClick();
    }
  }

  /**
   * Reset the focus to the top of the page when the button is activated
   * @private
   */
  _resetFocus() {
    const focusedElement = document.activeElement;
    if (!focusedElement) return;
    focusedElement.blur();
  }
}

customElements.define(ToujouTopButton.is, ToujouTopButton);
